import { useEffect } from 'react'

import { useDataBoxSelector } from 'app/common/data-box-store'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import {
  classesListFilterSelection,
  defaultStudentListDataReceiver,
  orgsFilterSelection,
  studentListFilter,
  studentListFilterSelection,
} from 'app/dataProviders/filter-items'

type Props = { id: string; pending: boolean }

export const StudentListFilter = ({ id, pending }: Props) => {
  const orgs = useDataBoxSelector(orgsFilterSelection, () => orgsFilterSelection.data)
  const classes = useDataBoxSelector(
    classesListFilterSelection,
    () => classesListFilterSelection.data,
  )
  const visible = orgs.length === 1 && classes.length === 1

  useEffect(() => {
    studentListFilterSelection.resetToDefault()
    if (visible) {
      studentListFilter.addDataReceiver(defaultStudentListDataReceiver)
      studentListFilter.dataReceive()
      studentListFilter.setStatusReady()
    } else {
      studentListFilter.resetToDefault()
    }
  }, [classes, visible])

  if (!visible) return null
  return (
    <PlainItemsSelectorBox
      id={id}
      label="Учащийся"
      header="Выбор учащегося"
      dataBoxData={studentListFilter}
      dataBoxSelection={studentListFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      multiple
      disabled={pending}
    />
  )
}
